import httpClient from 'shared/lib/httpClient';

export const loginOtp = async (formData) => {
  const response = await httpClient.post('/auth/otp', formData);
  return response?.data;
};
